import { render } from "./FormLegend.vue?vue&type=template&id=3c90288c&scoped=true&ts=true"
import script from "./FormLegend.vue?vue&type=script&lang=ts"
export * from "./FormLegend.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\nyffeler\\IdeaProjects\\data_tools\\Branches\\data_tools\\131\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c90288c"]])

export default __exports__